/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { DocumentAdminDetail } from './DocumentAdminDetail'
import {
  DocumentAdminDetailFromJSON,
  DocumentAdminDetailFromJSONTyped,
  DocumentAdminDetailToJSON,
} from './DocumentAdminDetail'

/**
 *
 * @export
 * @interface EnvelopedDocumentDocumentAdminDetail
 */
export interface EnvelopedDocumentDocumentAdminDetail {
  /**
   *
   * @type {DocumentAdminDetail}
   * @memberof EnvelopedDocumentDocumentAdminDetail
   */
  body: DocumentAdminDetail
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedDocumentDocumentAdminDetail
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedDocumentDocumentAdminDetail interface.
 */
export function instanceOfEnvelopedDocumentDocumentAdminDetail(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedDocumentDocumentAdminDetailFromJSON(
  json: any,
): EnvelopedDocumentDocumentAdminDetail {
  return EnvelopedDocumentDocumentAdminDetailFromJSONTyped(json, false)
}

export function EnvelopedDocumentDocumentAdminDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedDocumentDocumentAdminDetail {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: DocumentAdminDetailFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedDocumentDocumentAdminDetailToJSON(
  value?: EnvelopedDocumentDocumentAdminDetail | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: DocumentAdminDetailToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
